export default [
	{
		id: 'driving',
		name: 'Driving',
		verb: 'drive',
		by: 'car',
		radius: 50,
	},
	{
		id: 'bicycling',
		name: 'Cycling',
		verb: 'bike ride',
		by: 'bike',
		radius: 20,
	},
	{
		id: 'walking',
		name: 'Walking',
		verb: 'walk',
		by: 'foot',
		radius: 5,
	},
]
